import { useMemo } from 'react';
import { getSupportedFileExtensions } from '@/utils/validation';

export const useSupportedFileTypes = () => {
  const allExtensions = useMemo(() => getSupportedFileExtensions().split(', '), []);

  return { allExtensions };
};
